import React, {FC, useCallback} from "react";
import {Drawer, Select, DatePicker} from "antd";
import moment, {Moment} from "moment";
import styles from "./assistantApp.less";

interface AssistantFilterDrawerProps {
    open: boolean;
    onClose: () => void;
    selectedCity?: string;
    onCityChange: (value: string | undefined) => void;
    cityOptions: {label: string; value: string}[];
    selectedLocationId?: string;
    onLocationChange: (value: string | undefined) => void;
    locationOptions: {label: string; value: string}[];
    selectedMonth: Date | null;
    onMonthChange: (month: Date | null) => void;
}

const AssistantFilterDrawer: FC<AssistantFilterDrawerProps> = ({
    open,
    onClose,
    selectedCity,
    onCityChange,
    cityOptions,
    selectedLocationId,
    onLocationChange,
    locationOptions,
    selectedMonth,
    onMonthChange,
}) => {
    const handleMonthPickerChange = useCallback(
        (value: Moment | null) => {
            if (value) {
                onMonthChange(value.toDate());
            } else {
                onMonthChange(null);
            }
        },
        [onMonthChange]
    );

    const monthValue = selectedMonth ? moment(selectedMonth) : null;

    return (
        <Drawer
            title="Filter"
            placement="bottom"
            open={open}
            onClose={onClose}
            height="auto"
            bodyStyle={{paddingBottom: 24}}
            getContainer={false}
        >
            <div className={styles.assistantDrawerSection}>
                <div className={styles.assistantDrawerLabel}>{"Monat"}</div>
                <DatePicker
                    picker="month"
                    value={monthValue}
                    onChange={handleMonthPickerChange}
                    allowClear
                    placeholder="Standard (nächste 4 Wochen)"
                    format="MMMM YYYY"
                    style={{width: "100%"}}
                    getPopupContainer={(trigger) => trigger.parentElement || document.body}
                />
            </div>
            <div className={styles.assistantDrawerSection}>
                <div className={styles.assistantDrawerLabel}>{"Stadt"}</div>
                <Select
                    placeholder="Stadt hinzufügen..."
                    options={cityOptions}
                    allowClear
                    value={selectedCity}
                    onChange={(value) => onCityChange(value)}
                    style={{width: "100%"}}
                    getPopupContainer={(trigger) => trigger.parentElement || document.body}
                />
            </div>
            <div className={styles.assistantDrawerSection}>
                <div className={styles.assistantDrawerLabel}>{"Standort"}</div>
                <Select
                    placeholder="Standort hinzufügen..."
                    options={locationOptions}
                    allowClear
                    value={selectedLocationId}
                    onChange={(value) => onLocationChange(value)}
                    style={{width: "100%"}}
                    getPopupContainer={(trigger) => trigger.parentElement || document.body}
                />
            </div>
        </Drawer>
    );
};

export default AssistantFilterDrawer;
